<template>
    <div class="set-date-config">
        <div class="config-field">
            <label>{{ label }}</label>
            <a-radio-group v-model="localConfig.dateType" @change="emitChange" button-style="solid">
                <a-radio-button value="static">{{ $t("taskModuleRules.static") }}</a-radio-button>
                <a-radio-button value="relative">{{ $t("taskModuleRules.relative") }}</a-radio-button>
            </a-radio-group>
        </div>

        <div v-if="localConfig.dateType === 'static'" class="config-field">
            <a-date-picker
                v-model="localConfig.staticDate"
                :placeholder="$t('taskModuleRules.selectDate')"
                format="DD/MM/YYYY"
                style="width: 100%;"
                @change="emitChange"
            />
        </div>

        <div v-if="localConfig.dateType === 'relative'" class="relative-config">
            <div class="config-field">
                <label>{{ $t("taskModuleRules.value") }}</label>
                <a-input-number
                    v-model="localConfig.relativeValue"
                    :placeholder="$t('taskModuleRules.exampleThree')"
                    style="width: 100%;"
                    @change="emitChange"
                />
            </div>

            <div class="config-field">
                <label>{{ $t("taskModuleRules.unit") }}</label>
                <a-select
                    v-model="localConfig.relativeUnit"
                    style="width: 100%;"
                    @change="emitChange"
                >
                    <a-select-option value="minutes">{{ $t("taskModuleRules.minutes") }}</a-select-option>
                    <a-select-option value="hours">{{ $t("taskModuleRules.hours") }}</a-select-option>
                    <a-select-option value="days">{{ $t("taskModuleRules.days") }}</a-select-option>
                </a-select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SetDateConfig",
    props: {
        value: {
            type: Object,
            required: true
        },
        label: {
            type: String,
            default: 'Tarih'
        }
    },
    data() {
        return {
            localConfig: {
                dateType: 'static',
                staticDate: null,
                relativeValue: 1,
                relativeUnit: 'days'
            }
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        }
    }
};
</script>

<style lang="scss" scoped>
.set-date-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }
    }

    .relative-config {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }
}
</style>
